import { useMutation } from "@apollo/client";
import { trackEvent } from "../../helpers/analytics";
import emailjs from "emailjs-com";
import { CONNECT_TO_USER, DISCONNECT_TO_USER, RESPONSE_REQUEST_CONNECT, SEND_CONNECT } from "../../helpers/graphqlMutations";
import { sendPushNotifications } from "../../helpers/utils";

export default function useConnectionUsers(onCompletedAny = () => { }, onErrorAny = () => { }) {
  const [sendConnectBetweenUsernames] = useMutation(CONNECT_TO_USER, { onCompleted: onCompletedAny, onError: onErrorAny });
  const [disconnectBetweenUsernames] = useMutation(DISCONNECT_TO_USER, { onCompleted: onCompletedAny, onError: onErrorAny });
  const [sendConnectByRecommendedId] = useMutation(SEND_CONNECT, { onCompleted: onCompletedAny, onError: onErrorAny });
  const [responseRequestConnect] = useMutation(RESPONSE_REQUEST_CONNECT, { onCompleted: onCompletedAny, onError: onErrorAny });

  async function handleConnect(onConnect, username, usernameSender, ownerProfileName, toEmail) {
    // console.log(onConnect, username, usernameSender, ownerProfileName)
    if (!ownerProfileName) return alert("Let's make the connection meaningful! Complete your profile to connect 😃")
    if (!onConnect) {
      await sendConnectBetweenUsernames({
        variables: {
          usernames: [username, usernameSender],
          sender: usernameSender,
        },
      });
      sendConnectRequestEmail(toEmail,username)
      sendPushNotifications([toEmail],'🎉 GABA Connection in the Works!', 'GABA members have requested to connect with you')
      trackEvent('ConnectToUser', {
        reciver_email: username,
        sender_email: usernameSender
      });
    } else if (onConnect?.status === 2) {
      await disconnectBetweenUsernames({
        variables: {
          username1: username,
          username2: usernameSender
        },
      });
    } else if (onConnect?.status === 1 && onConnect?.sender === "Recommended") {
      await sendConnectByRecommendedId({
        variables: {
          id: onConnect.id,
          senderUsername: usernameSender
        }
      })
    }
  }

  async function acceptConnectionById(id) {
    await responseRequestConnect({
      variables: {
        id: id,
        status: 2
      }
    })
  }

  async function declineConnectionById(id) {
    await responseRequestConnect({
      variables: {
        id: id,
        status: 3
      }
    })
  }

  return {
    handleConnect,
    acceptConnectionById,
    declineConnectionById
  }

}

async function sendConnectRequestEmail(toEmail,username) {
  // console.log(toEmail,username)
  if(!toEmail)return;
  const template_params = {
    toEmail,
    username
  };
  const service_id = "default_service";
  const template_id = "connect_request";
  const user_id = "user_yIq3IIfTQ8ruKbjBAqYaQ";
  await emailjs.send(service_id, template_id, template_params, user_id).catch((e)=>console.log(e));
}